/* KC Wishlist — lightweight browser-based wishlist for Khadija's Abaya Closet */
(function () {
  var KEY = 'kc-wishlist';

  function get() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function save(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    updateBadge();
  }
  function has(handle) { return get().indexOf(handle) > -1; }
  function toggle(handle) {
    var list = get();
    var i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); } else { list.push(handle); }
    save(list);
    return i === -1;
  }
  function updateBadge() {
    var n = get().length;
    document.querySelectorAll('[data-kc-wl-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  /* Heart button on product pages */
  function initProductPage() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var handle = decodeURIComponent(m[1]);
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form || document.querySelector('.kc-wl-btn')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kc-wl-btn';
    function paint(on) {
      btn.innerHTML = on ? '&#9829;&nbsp; In your wishlist' : '&#9825;&nbsp; Add to wishlist';
      btn.classList.toggle('kc-wl-btn--on', on);
    }
    paint(has(handle));
    btn.addEventListener('click', function () { paint(toggle(handle)); });
    form.parentNode.insertBefore(btn, form.nextSibling);
  }

  /* Heart overlay on product card images (collections, featured grids, search) */
  function handleFromLink(el) {
    var m = (el.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function initCardHearts() {
    document.querySelectorAll('.card-gallery').forEach(function (gallery) {
      if (gallery.querySelector('.kc-wl-card-heart')) return;
      var link =
        gallery.closest('a[href*="/products/"]') ||
        gallery.querySelector('a[href*="/products/"]') ||
        (gallery.parentElement && gallery.parentElement.querySelector('a[href*="/products/"]')) ||
        (gallery.closest('[class*="product-card"], li, article') || document.createElement('div')).querySelector('a[href*="/products/"]');
      if (!link) return;
      var handle = handleFromLink(link);
      if (!handle) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kc-wl-card-heart';
      btn.setAttribute('aria-label', 'Add to wishlist');
      function paint(on) {
        btn.innerHTML = on ? '&#9829;' : '&#9825;';
        btn.classList.toggle('kc-wl-card-heart--on', on);
      }
      paint(has(handle));
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        paint(toggle(handle));
      });
      if (getComputedStyle(gallery).position === 'static') {
        gallery.style.position = 'relative';
      }
      gallery.appendChild(btn);
    });
  }
  var heartsTimer;
  function watchForNewCards() {
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function () {
      clearTimeout(heartsTimer);
      heartsTimer = setTimeout(initCardHearts, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* Wishlist page grid */
  function initWishlistPage() {
    var root = document.getElementById('kc-wishlist-root');
    if (!root) return;
    var list = get();
    if (!list.length) {
      root.innerHTML =
        '<p class="kc-wl-empty">Your wishlist is empty &mdash; tap the &#9825; on any piece you love and it will wait for you here.</p>' +
        '<p class="kc-wl-empty-cta"><a href="/collections/all-abayas">Shop the collection &rarr;</a></p>';
      return;
    }
    root.innerHTML = '<div class="kc-wl-grid"></div>';
    var grid = root.firstChild;
    list.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { if (!r.ok) throw new Error('unavailable'); return r.json(); })
        .then(function (p) {
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var card = document.createElement('div');
          card.className = 'kc-wl-card';
          card.innerHTML =
            '<a href="' + p.url + '">' +
            (img ? '<img loading="lazy" src="' + img + '" alt="">' : '') +
            '<h3>' + p.title + '</h3>' +
            '<p>' + money(p.price) + '</p>' +
            '</a>' +
            '<button type="button" class="kc-wl-remove">Remove</button>';
          card.querySelector('.kc-wl-remove').addEventListener('click', function () {
            toggle(handle);
            card.remove();
            if (!get().length) initWishlistPage();
          });
          grid.appendChild(card);
        })
        .catch(function () { /* product hidden or removed — skip quietly */ });
    });
  }

  function init() {
    updateBadge();
    initProductPage();
    initCardHearts();
    watchForNewCards();
    initWishlistPage();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
